import { GetterTree } from 'vuex'
import { State } from '@plugin/store'

const getters: GetterTree<State, State> = {
  token: (state) => {
    return state.app.token
  },
  supDistinguish: (state) => {
    return state.app.supDistinguish
  },
  dbName: (state) => {
    return state.app.dbName
  },
  loading: (state) => {
    return !!state.app.loadingList.length
  },
  userInfo: (state) => {
    return state.app.userInfo
  },
  documentWidth: (state) => {
    return state.app.documentWidth
  },
  documentHeight: (state) => {
    return state.app.documentHeight
  },
  appWidth: (state) => {
    return state.app.appWidth
  },
  appHeight: (state) => {
    return state.app.appHeight
  },
  scrollTop: (state) => {
    return state.app.scrollTop
  },
  atBottom: (state) => {
    return state.app.atBottom
  },
  scrollBottom: (state) => {
    return state.app.scrollBottom
  },
  fixedMenu: (state) => {
    return state.app.fixedMenu
  },
  language: (state) => {
    return state.app.language
  },
  remoteBarcode: (state) => {
    return state.app.remoteBarcode
  },
  menus: (state) => {
    return state.menu.menus
  },
  menusMap: (state) => {
    return state.menu.menusMap
  },
  routesMap: (state) => {
    return state.menu.routesMap
  },
  recentMenus: (state) => {
    return state.menu.recentMenus
  },
  fixedMenus: (state) => {
    return state.menu.fixedMenus
  },
  colomnRules: (state) => {
    return state.menu.colomnRules
  },
  guideInfo: (state) => {
    return state.app.guideInfo
  },
  expectedArrivalDate: (state) => {
    return state.asn.expectedArrivalDate
  },
  remark: (state) => {
    return state.asn.remark
  },
  asnHeadFileList: (state) => {
    return state.asn.asnHeadFileList
  },
  invoice: (state) => {
    return state.asn.invoice
  },
  deliveryAddressId: (state) => {
    return state.asn.deliveryAddressId
  },
  shippingAddressId: (state) => {
    return state.asn.shippingAddressId
  },
  options1: (state) => {
    return state.asn.options1
  },
  options2: (state) => {
    return state.asn.options2
  },
  consigneeInfo: (state) => {
    return state.asn.consigneeInfo
  },
  shipper: (state) => {
    return state.asn.shipper
  }
}
export default getters
